// Only fixed identifiers may cross the analytics boundary. Never accept input values or URLs verbatim.
export const CONTACT_FIELDS: Record<string, string> = {
    name: "Name", firstName: "First name", lastName: "Last name", email: "Email",
    phone: "Phone", postalCode: "ZIP code", preferredTime: "Preferred time",
    message: "Message", consentToPromotions: "Marketing consent"
};
export function safeContactField(value: unknown): string | undefined {
    return typeof value === "string" && Object.hasOwn(CONTACT_FIELDS, value) ? value : undefined;
}
export function fieldFromTarget(target: EventTarget | null): string | undefined {
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement)) return;
    return safeContactField(target.name || target.id);
}
export function safeFlowPage(path: string): string {
    const clean = path.split(/[?#]/)[0];
    if (clean === "/sell-my-car" || clean === "/finance" || clean === "/cars" || clean === "/") return clean;
    if (/^\/cars\/[^/]+\/?$/.test(clean ?? "")) return "/cars/[vin]";
    return "unknown";
}
export const FLOW_PAGE_NAMES: Record<string, string> = {
    "/sell-my-car": "Sell My Car page", "/cars/[vin]": "Vehicle detail pages",
    "/cars": "Vehicle search", "/finance": "Finance page", "/": "Homepage", unknown: "Page not recorded"
};
